export default {"src":"/_next/static/media/reward_24.9fb6efe2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};